import { useEffect } from "react";
import { RatingConversionCard } from "./card";
import { RatingConversionNew } from "./new";
import { Routes, Route } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { RatingConversionsTable } from "./table";

export default function RatingConversion() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Conversions de notation");
  }, []);

  return (
    <Routes>
      <Route index element={<RatingConversionsTable />} />
      <Route path="/new" element={<RatingConversionNew />} />
      <Route path=":id" element={<RatingConversionCard />} />
    </Routes>
  );
}
